<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col lg="8">
          <base-material-card>
            <template #heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <v-row>
                <v-col>
                  <va-field source="name"></va-field>
                </v-col>
                <v-col>
                  <va-field v-if="item?.createdAt" source="createdAt" type="date" class="mt-0 pt-0">
                    {{ new Date(item.createdAt).toLocaleDateString('en-CA') }}
                  </va-field>
                  <va-field v-if="item?.lastUpdatedAt" source="lastUpdatedAt" type="date">
                    {{ new Date(item.lastUpdatedAt).toLocaleDateString('en-CA') }}
                  </va-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <va-field v-if="item?.description" source="description">
                    <div v-html="item.description"></div>
                  </va-field>
                </v-col>
              </v-row>
              <va-field v-if="item.logoImageID" source="Image ID" class="mt-0 pt-0">
                {{ item.logoImageID }}
              </va-field>
              <resource-image v-if="item.logoImageID" class="ma-10" :resource-id="item.logoImageID" big-picture />
              <v-row>
                <disableable-button :disabled="!saveButtonAvailable">
                  <va-save-button redirect="list" label="Save"></va-save-button>
                </disableable-button>
              </v-row>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
import ResourceImage from '@/components/base/ResourceImage.vue';

export default {
  components: {
    ResourceImage,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
